<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <base-alert type="danger" v-if="user.emailVerified == false">
                    <strong>¡Atención!</strong> ¡Su email está todavía pendiente de verificación!
                </base-alert>
            <div class="row">
                <div class="col-xl-4 col-lg-6">
                    <router-link v-if="dietaId" :to="{ name: 'Ver Dieta', params: { dietaId: dietaId}}">
                        <stats-card title="Dieta actual"
                                type="gradient-red"
                                :sub-title="dieta_name"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-warning mr-2"> Caduca:</span>
                            <span class="text-nowrap">{{dieta_fin}}</span>
                        </template>
                        </stats-card>
                    </router-link>
                    <router-link v-else :to="{ name: 'Crear Dieta'}">
                        <stats-card title="No hay Dieta actual"
                                type="gradient-red"
                                sub-title="Haz click para crear una dieta"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">

                        </template>
                        </stats-card>
                    </router-link>
                </div>
                <div class="col-xl-4 col-lg-6">
                  <router-link v-if="rutinaId" :to="{ name: 'Ver Rutina', params: { rutinaId: rutinaId}}">
                    <stats-card title="Rutina actual"
                                type="gradient-orange"
                                :sub-title="rutina_name"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2">Caduca: </span>
                            <span class="text-nowrap">{{rutina_fin}}</span>
                        </template>
                    </stats-card>
                  </router-link>
                  <router-link v-else :to="{ name: 'Crear Rutina'}">
                    <stats-card title="No hay Rutina actual"
                                type="gradient-orange"
                                sub-title="Haz click para crear una rutina"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">
                        <template slot="footer">
                        </template>
                    </stats-card>
                  </router-link>
                </div>
                <div class="col-xl-4 col-lg-6">
                  <router-link v-if="peso > 0.0" to="/pesos" class="text-light">
                    <stats-card title="Registro de peso (Kg)"
                                type="gradient-info"
                                :sub-title="peso"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2" v-if="peso_dif > 0"><i class="fa fa-arrow-up"></i> {{Math.round((peso_dif + Number.EPSILON) * 100) / 100}}Kg</span>
                            <span class="text-danger mr-2" v-else><i class="fa fa-arrow-down"></i> {{Math.round((peso_dif + Number.EPSILON) * 100) / 100}}Kg</span>
                            <span class="text-nowrap">desde la última vez</span>
                        </template>
                    </stats-card>
                  </router-link>
                  <router-link v-else to="/pesos" class="text-light">
                    <stats-card title="Registro de peso (Kg)"
                                type="gradient-info"
                                sub-title="Añade registros de peso"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">

                        </template>
                    </stats-card>
                  </router-link>
                </div>
            </div>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <card type="default" header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-light text-uppercase ls-1 mb-1">Gráfico</h6>
                                <h5 class="h3 text-white mb-0">Registro de peso</h5>
                            </div>
                            <div class="col">
                                
                            </div>
                        </div>
                        <line-chart
                                :height="350"
                                ref="bigChart"
                                :chart-data="bigLineChart.chartData"
                                :extra-options="bigLineChart.extraOptions"
                        >
                        </line-chart>

                    </card>
                </div>

                <div class="col-xl-4">
                        <pesos-table-min></pesos-table-min>
                </div>
            </div>
            <!-- End charts-->

           
        </div>
      <div class="ml-5 mr-5 pb-6 pb-8 pt-5 pt-md-5">
        <div class="row">
          <div class="col-xl-4 col-lg-6">
                    <stats-card class="bg-gradient-default">
                        <!-- Card body -->
                        <div class="row">
                            <div class="col">
                                <h5 class="card-title text-uppercase text-muted mb-0 text-white">Ejercicio recomendado</h5>
                                <span class="h2 font-weight-bold mb-0 text-white">Sentadilla</span>
                            </div>
                            <div class="col-auto">
                                <div class="icon icon-shape bg-white text-dark rounded-circle shadow">
                                    <i class="ni ni-air-baloon"></i>
                                </div>
                            </div>
                        </div>
                        <p class="mt-3 mb-0 text-sm">
                            <span class="text-white mr-2">Fántastico ejercicio para mejorar el tren inferior.</span>
                            <br>
                            <router-link :to="{ name: 'Ver Ejercicio', params: { ejercicioId: 'FIpK4ORo8PjA94WwZO2q'}}"><span class="text-nowrap text-light"> Ver más sobre la sentadilla</span></router-link>
                        </p>
                    </stats-card>
          </div>
          <div class="col-xl-4 col-lg-6">
              <stats-card class="bg-gradient-primary">
                  <!-- Card body -->
                  <div class="row">
                      <div class="col">
                          <h5 class="card-title text-uppercase text-muted mb-0 text-white">Ejercicio recomendado</h5>
                          <span class="h2 font-weight-bold mb-0 text-white">Peso muerto</span>
                      </div>
                      <div class="col-auto">
                          <div class="icon icon-shape bg-white text-dark rounded-circle shadow">
                              <i class="ni ni-air-baloon"></i>
                          </div>
                      </div>
                  </div>
                  <p class="mt-3 mb-0 text-sm">
                      <span class="text-white mr-2">Uno de los ejercicios que más músculos requiere.</span>
                      <br>
                      <router-link :to="{ name: 'Ver Ejercicio', params: { ejercicioId: 'WObvnmvr1AnKTpd9nqtq'}}"><span class="text-nowrap text-light"> Ver más sobre el peso muerto</span></router-link>
                      
                  </p>
              </stats-card>
          </div>
          <div class="col-xl-4 col-lg-6">
              <stats-card class="bg-gradient-default">
                  <!-- Card body -->
                  <div class="row">
                      <div class="col">
                          <h5 class="card-title text-uppercase text-muted mb-0 text-white">Ejercicio recomendado</h5>
                          <span class="h2 font-weight-bold mb-0 text-white">Press banca</span>
                      </div>
                      <div class="col-auto">
                          <div class="icon icon-shape bg-white text-dark rounded-circle shadow">
                              <i class="ni ni-air-baloon"></i>
                          </div>
                      </div>
                  </div>
                  <p class="mt-3 mb-0 text-sm">
                      <span class="text-white mr-2">Ejercicio básico para conseguir un pectoral grande.</span>
                      <br>
                      
                      <router-link :to="{ name: 'Ver Ejercicio', params: { ejercicioId: '6dsXvpjoDFB8hCtzjCLf'}}"><span class="text-nowrap text-light"> Ver más sobre el press banca</span></router-link>
                  </p>
              </stats-card>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  import { db } from '../firebaseDb';
  import { auth } from '../firebaseDb';
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import LineChart from '@/components/Charts/LineChart';

  // Tables
  import PesosTableMin from './Tables/PesosTableMin';

  export default {
    components: {
      LineChart,
      PesosTableMin,
    },
    data() {
      return {
        user: auth.currentUser,
        dieta_name: "",
        dieta_fin: "",
        dietaId: "",
        rutina_name: "",
        rutina_fin: "",
        rutinaId: "",
        peso: "0.0",
        peso_fecha: "",
        peso_dif: 0.0,
        pesos: [[]],
        labels: [],
        bigLineChart: {
          allData: [
            [],
            []
          ],
          activeIndex: 0,
          chartData: {
            datasets: [],
            labels: [],
          },
          extraOptions: chartConfigs.blueChartOptions,
        },
      };
    },
    methods: {
      async initBigChart(index) {
        const {contenido} = await this.cargarArrays();
        let chartData = {
          datasets: [
            {
              label: 'Peso (Kg)',
              data: this.pesos[index]
            }
          ],
          labels: this.labels,
        };
        this.bigLineChart.chartData = chartData;
        this.bigLineChart.activeIndex = index;
      },
      async cargarArrays(){
        const snapshot = await db.collection('users').doc(this.user.uid).collection('pesos').orderBy("fecha", "desc").limit(7).get()
        snapshot.forEach(doc => {
                    let item = doc.data()
                      item.id = doc.id
                      item.peso = parseFloat(doc.data().peso);
                      item.fecha = doc.data().fecha.toDate().toLocaleDateString('es-ES')
                    this.pesos[0].unshift(item.peso)
                    this.labels.unshift(item.fecha)
                })
        return true;
      }
    },
    async mounted() {
      this.initBigChart(0);
    },
    created: function(){
        db.collection('users').doc(this.user.uid).collection('dietas').get()
            .then(snapshot => this.count_dietas = snapshot.size);
        var beginningDate = Date.now();
        var beginningDateObject = new Date(beginningDate);
        db.collection('users').doc(this.user.uid).collection('dietas').where("fecha_fin", ">", beginningDateObject).orderBy("fecha_fin", "asc").limit(1).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    let item = doc.data()
                    item.id = doc.id
                    this.dieta_name = item.dieta_name
                    this.dieta_fin = item.fecha_fin.toDate().toLocaleDateString('es-ES')
                    this.dietaId = item.id
                })
            })
        db.collection('users').doc(this.user.uid).collection('rutinas').where("fecha_fin", ">", beginningDateObject).orderBy("fecha_fin", "asc").limit(1).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    let item = doc.data()
                    item.id = doc.id
                    this.rutina_name = item.rutina_name
                    this.rutina_fin = item.fecha_fin.toDate().toLocaleDateString('es-ES')
                    this.rutinaId = item.id
                })
            })
        db.collection('users').doc(this.user.uid).collection('pesos').orderBy("fecha", "desc").limit(2).get()
            .then(snapshot => {
                let i = 0
                snapshot.forEach(doc => {
                    let item = doc.data()
                    if(i == 0){
                      item.id = doc.id
                      this.peso = item.peso
                      this.peso_fecha = item.fecha.toDate().toLocaleDateString('es-ES')
                      i++
                    }
                    this.peso_dif = this.peso - item.peso
                })
            })

    }
  };
</script>
<style></style>
